<template>
  <div></div>
</template>
    
<script>
export default {
  name: "before",
  data() {
    return {
      token: "" // 数据绑定示例
    };
  },
  created() {
    const token = this.$route.query.token;
    if (token == undefined) {
      localStorage.removeItem("token");
    } else {
      localStorage.setItem("token", token);
    }
    this.$router.push({ name: "index" });
    // console.log("Token set:", token);
  },
  methods: {
    // 设置 token 到 localStorage
    setToken() {
      const token = "your_token_value";
      localStorage.setItem("token", token);
      // console.log("Token set:", token);
    },

    // 从 localStorage 获取 token
    getToken() {
      const token = localStorage.getItem("token");
      this.token = token; // 绑定到 data
      // console.log("Token retrieved:", token);
    },

    // 删除 token
    removeToken() {
      localStorage.removeItem("token");
      this.token = ""; // 同步清空绑定数据
      // console.log("Token removed.");
    }
  }
};
</script>
    
<style scoped>
</style>
    


// WEBPACK FOOTER //
// src/view/before.vue